"use client";

import { useEffect } from "react";

import { useSearch } from "@/lib/search-context";

export function SearchHotkey() {
  const { open, setOpen } = useSearch();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "k" || (!e.metaKey && !e.ctrlKey)) return;
      const target = e.target as HTMLElement | null;
      if (target) {
        const tag = target.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA" || target.isContentEditable) {
          // Allow only if the dialog is already open (its own input).
          if (!open) return;
        }
      }
      e.preventDefault();
      setOpen(!open, "header");
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, setOpen]);

  return null;
}
